import { Controller } from "@hotwired/stimulus";
export default class TurboController extends Controller {
  initialize() {
    if (this.element.dataset.action == undefined) {
      this.element.dataset.action = "click->turbo#click";
    }
  }

  async click(e) {
    e.preventDefault();
    this.url = this.element.getAttribute("href");

    const turboRequest = (await import("../helpers/api")).turboRequest;
    await turboRequest(this.url, {
      method: "GET",
      turboStream: true,
    });
  }
}
